import UserService from '../../services/models/UserService';
import { CREATE_USER, SET_USER, LOGIN, LOGOUT, SET_LOGIN_DATA, CHANGE_PASSWORD, MAIL_RECOVER, UPDATE_USER, SET_ACCOUNT } from '../mutations';
import { ROUTE_PROVIDER_DASHOVER, ROUTE_HOME_ACCOUNT } from '../../router/routes'
import router from '../../router';

const userService = UserService.build();

export default {

    namespaced: true,

    state: {

        user: {},
        loginData: null

    },

    getters: {

        user: state => state.user,
        loginData: state => state.loginData,

    },

    mutations: {

        [SET_USER]: (state, userData) => {
            state.user = userData;

        },
        [SET_LOGIN_DATA]: (state, data) => {
            state.loginData = data;

        },

    },

    actions: {

        [LOGIN]: async ({ commit }, { email, password }) => {

            const response = await userService.login(email, password);

            if (response) {

                localStorage.setItem('token', response.token)

                commit(SET_USER, response.userAccount.owner);

                commit(`AccountVuex/${SET_ACCOUNT}`, response.account, {root: true});

                return router.push(ROUTE_PROVIDER_DASHOVER);
            }

            return false


        },
        [LOGOUT]: async ({ commit }) => {

            await userService.logout();

            await commit(SET_USER, {});

            localStorage.removeItem('logged_user');
            localStorage.removeItem('token');

            return await router.push(ROUTE_HOME_ACCOUNT);

        },

        [CHANGE_PASSWORD]: async (context, updateData) => {

            try {

                return await userService.updatePassword(updateData)

            } catch (error) {

                throw new Error(error)

            }

        },

        [CREATE_USER]: async ({ commit }, user) => {

            user.phone = user.phone.match(/\d+/g).join('')

            try {

                const userReturn = await userService.create(user);

                commit(SET_USER, userReturn)
                commit(SET_LOGIN_DATA, { email: user.email, password: user.password })

                return userReturn

            } catch (error) {

                console.log(error)

                throw error

            }

        },

        [UPDATE_USER]: async (context, updateData) => {

            if (!updateData.password2) {
                delete updateData.password
                delete updateData.password2
            }

            try {

                return await userService.update(updateData);

            } catch (error) {

                console.log(error)

                throw error

            }

        },

        [MAIL_RECOVER]: async (context, data) => {

            return await userService.recoverEmail(data.email, data.locale)

        },

    }
}